module.exports = __webpack_public_path__ + "static/media/piano-keyboard.26abe2eb.svg";